import "./contact.css";

import React from "react";
import { connect } from "react-redux";
import { TextField } from "@mui/material";

import { notifSelectors } from "../../logic/rootSelectors";
import _contact from "../../logic/contact";
import { CONTACT } from "../../data/content";
import { SECTIONS, LS_ITEM, CONTACT_DETAILS } from "../../utils/stateTypes";
import Reveal from "../general/Reveal";
import SaveButton from "../general/SaveButton";

const EMPTY = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  company: "",
  message: "",
  website: "",
};

const Contact = ({ sendLS, sendContactMessage }) => {
  const [form, setForm] = React.useState(EMPTY);
  const [isSent, setIsSent] = React.useState(false);

  const update = (prop) => (e) => setForm({ ...form, [prop]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    sendContactMessage(form, () => {
      setForm(EMPTY);
      setIsSent(true);
    });
  };

  return (
    <section
      id={SECTIONS.CONTACT}
      className={"section contact"}
    >
      <div className={"container"}>
        {/* The card glides up into place, like the original */}
        <Reveal
          className={"contact-card"}
          variant={"glide"}
        >
          <div className={"contact-intro"}>
            <h2 className={"contact-title"}>{CONTACT.title}</h2>
            <img
              className={"contact-photo"}
              src={"/images/corlea.jpg"}
              alt={"Corlea Geyer"}
              width={774}
              height={800}
              loading={"lazy"}
            />
            <p className={"contact-direct"}>
              Or reach Corlea directly on{" "}
              <a href={CONTACT_DETAILS.PHONE_LINK}>{CONTACT_DETAILS.PHONE}</a>
              {" "}or{" "}
              <a href={`mailto:${CONTACT_DETAILS.EMAIL}`}>{CONTACT_DETAILS.EMAIL}</a>
            </p>
          </div>

          <div className={"contact-form-wrap"}>
            {isSent ? (
              <div
                className={"contact-sent"}
                role={"status"}
              >
                <h3>Thank you!</h3>
                <p>Your message has been sent. Corlea will be in touch with you soon.</p>
                <button
                  type={"button"}
                  className={"contact-sent-again"}
                  onClick={() => setIsSent(false)}
                >
                  Send another message
                </button>
              </div>
            ) : (
              <form
                className={"contact-form"}
                onSubmit={onSubmit}
              >
                <TextField
                  variant={"standard"}
                  label={"First name"}
                  value={form.firstName}
                  onChange={update("firstName")}
                  required
                  fullWidth
                  autoComplete={"given-name"}
                  inputProps={{ maxLength: 100 }}
                />
                <TextField
                  variant={"standard"}
                  label={"Last name"}
                  value={form.lastName}
                  onChange={update("lastName")}
                  required
                  fullWidth
                  autoComplete={"family-name"}
                  inputProps={{ maxLength: 100 }}
                />
                <TextField
                  variant={"standard"}
                  label={"Email"}
                  value={form.email}
                  onChange={update("email")}
                  required
                  fullWidth
                  type={"email"}
                  autoComplete={"email"}
                  inputProps={{ maxLength: 200 }}
                />
                <TextField
                  variant={"standard"}
                  label={"Phone"}
                  value={form.phone}
                  onChange={update("phone")}
                  fullWidth
                  type={"tel"}
                  autoComplete={"tel"}
                  inputProps={{ maxLength: 30 }}
                />
                <TextField
                  className={"contact-full"}
                  variant={"standard"}
                  label={"Company / Organization"}
                  value={form.company}
                  onChange={update("company")}
                  fullWidth
                  autoComplete={"organization"}
                  inputProps={{ maxLength: 200 }}
                />
                <TextField
                  className={"contact-full"}
                  variant={"standard"}
                  label={"How can we help?"}
                  value={form.message}
                  onChange={update("message")}
                  fullWidth
                  multiline
                  minRows={3}
                  inputProps={{ maxLength: 5000 }}
                />
                {/* Honeypot - hidden from people and screen readers, bots fill it in */}
                <input
                  className={"contact-hp"}
                  type={"text"}
                  name={"website"}
                  tabIndex={-1}
                  autoComplete={"off"}
                  aria-hidden={"true"}
                  value={form.website}
                  onChange={update("website")}
                />
                <SaveButton
                  label={"Submit"}
                  loadingState={sendLS}
                  size={"large"}
                  contStyle={{ gridColumn: "1 / -1" }}
                  style={{ width: "100%", maxWidth: "100%", margin: "12px 0 0 0", height: 50 }}
                />
              </form>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    sendLS: notifSelectors.getLoadState(state)(LS_ITEM.CONTACT_SEND),
  };
};

const connected = connect(
  mapStateToProps,
  {
    sendContactMessage: _contact.actions.sendContactMessage,
  },
)(Contact);

export default connected;
